module.exports = __webpack_public_path__ + "3358fa3c59392ad698d8f93adac4cacc.png";